import React, { useContext, useState } from 'react';
import AppContext from '../Context/AppContext';
import Reminder from '../components/Reminder/Reminder';
import remIcoCutom from "../assets/images/reminder_icon_custom.svg";
import { UncontrolledTooltip } from 'reactstrap';

export default function ReminderWrapper() {
  const AppData = useContext(AppContext);
  const [reminderFlag, setReminderFlag] = useState(false);
  const { dispatch ,state} = AppData || {}; 

  return (<div id="reminder-icon">
                    <UncontrolledTooltip placement="top" target="reminder-icon">
                      Reminder
                    </UncontrolledTooltip>
                    <img
                      onClick={() => setReminderFlag(true)}
                      className="reminder-icon-cust"
                      style={{ backgroundColor: "rgb(242, 111, 86)" }}
                      src={remIcoCutom}
                    /> 
                    <Reminder
                      id="General"
                      users={state.AllAppUsers}
                      show={reminderFlag}
                      onClose={() => setReminderFlag(false)}
                    />
                  </div>
         )
}
